// extracted by mini-css-extract-plugin
module.exports = {"outer":"Meal_outer__197ms","info-panel":"Meal_info-panel__3xS-o","nutrition-breakdown":"Meal_nutrition-breakdown__2wz0r","add-meal":"Meal_add-meal__3n2Pr"};